export const initialValues: { [key: string]: { [key: string]: any } } = {
  name: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  title: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  duties: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
  noOfServiceYears: {
    value: '',
    error: '',
    isTouched: false,
    rules: {
      type: 'string',
      required: true,
    },
  },
};
